module.exports = __webpack_public_path__ + "img/0Q3A5801_L_WoodMatted_MockedUp.3c63d6bf.jpg";